jQuery(document).ready(function ($) {
    tippy('#tooltip-price', {
        content:
            '<strong>Bolti ár:</strong> Az internetes rendelésre érvényes ár, amely minden vásárló számára elérhető. <br><strong class="price-erawan">Erawan ár:</strong> Az exkluzív törzsvásárlói ár, amely csak regisztrált tagjainknak jár. Legyél Te is törzsvásárlónk, és élvezd a kiemelt kedvezményeket! <br>Csatlakozz most a törzsvásárlói programunkhoz, és vásárolj Erawan áron már az első rendelésedtől kezdve!<br><a href="/torzsvasarloi-kedvezmenyek">További információ</a><br><a href="/my-account/">Regisztrálok a törzsvásárlói programba</a>',
        allowHTML: true,
        interactive: true,
    });
});
